import { render, staticRenderFns } from "./DetailDrawer.vue?vue&type=template&id=16e4c624&scoped=true"
import script from "./DetailDrawer.vue?vue&type=script&lang=js"
export * from "./DetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./DetailDrawer.vue?vue&type=style&index=0&id=16e4c624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e4c624",
  null
  
)

export default component.exports